<template>
	<div class="mail_form">
		<v-cover
			class="mail_form__cover"
			:image="require('@/assets/images/portrait-diagnosis.png')"
			:title="$t('diagnosis.onTheWay')"
		/>

		<!-- can be v-ifed if the result calculation in incomplete -->
		<div class="mail_form__fields" ref="formContainer" v-if="true">
			<form @submit.prevent="submitForm" class="klaviyo-form">
				<p class="mail_form__heading" :class="{ jp: isJapanese }">
					{{ $t('mailForm.heading') }}
				</p>
				<input
					type="text"
					v-model="name"
					:placeholder="$t('mailForm.firstNamePlaceholder')"
					required
				/>
				<input
					type="email"
					v-model="email"
					:placeholder="$t('mailForm.emailPlaceholder')"
					required
				/>

				<div class="opt-in-container">
					<!-- Japanese specific layout -->
					<template v-if="isJapanese">
						<div class="opt-in">
							<input
								type="checkbox"
								id="privacy-consent"
								v-model="dataConsentAllowCollect"
								required
							/>
							<label for="privacy-consent">
								<span v-html="privacyPolicyText"></span>
							</label>
						</div>
						<div class="opt-in">
							<input
								type="checkbox"
								id="diagnosis-consent"
								v-model="dataConsentAllowSendRecap"
								required
							/>
							<label for="diagnosis-consent">
								<span v-html="diagnosisConsentText"></span>
							</label>
						</div>
						<div class="opt-in">
							<input
								type="checkbox"
								id="marketing-consent-jp"
								v-model="marketingConsent"
								required
							/>
							<label for="marketing-consent-jp">
								<span v-html="marketingConsentText"></span>
							</label>
						</div>
					</template>

					<!-- Original layout for other languages -->
					<template v-else>
						<div class="opt-in__multiple">
							<span class="opt-in__multiple-start">
								{{ $t('mailForm.dataConsent_start') }}
							</span>
							<div class="opt-in__wrapper">
								<div class="opt-in">
									<input
										type="checkbox"
										id="marketing-consent"
										v-model="marketingConsent"
										required
									/>
									<label for="marketing-consent">
										{{ $t('mailForm.marketingConsent') }}
									</label>
								</div>
								<div class="opt-in">
									<input
										type="checkbox"
										id="data-consent-allow-collect"
										v-model="dataConsentAllowCollect"
										required
									/>
									<label for="data-consent-allow-collect">
										{{
											$t(
												'mailForm.dataConsent_allow_collect'
											)
										}}
									</label>
								</div>
								<div class="opt-in">
									<input
										type="checkbox"
										id="data-consent-allow-send-recap"
										v-model="dataConsentAllowSendRecap"
										required
									/>
									<label for="data-consent-allow-send-recap">
										{{
											$t(
												'mailForm.dataConsent_allow_send_recap'
											)
										}}
									</label>
								</div>
							</div>
						</div>

						<div class="text-info-container">
							<p class="info-text">
								{{ $t('mailForm.infoText_0') }}
							</p>
							<p class="info-text">
								{{ $t('mailForm.infoText_1') }}
								<a
									target="_blank"
									:href="$t('mailForm.infoText_2_href')"
								>{{ $t('mailForm.infoText_2') }}</a
								>
								{{ $t('mailForm.infoText_3') }}
								<a :href="$t('mailForm.infoText_4_href')">{{
									$t('mailForm.infoText_4')
								}}</a
								>.
							</p>
						</div>
					</template>
				</div>

				<span v-show="submissionSuccess" class="success">{{
					$t('mailForm.submissionSuccess')
				}}</span>
				<span v-show="submissionFail" class="fail">{{
					$t('mailForm.submissionFail')
				}}</span>
				<button type="submit" :disabled="isLoading">
					{{
						isLoading
							? $t('mailForm.loading')
							: $t('mailForm.confirm')
					}}
				</button>
			</form>
			<v-button
				color="transparent"
				:secondary="true"
				style="color: white"
				:disabled="isLoading"
				@click="() => $router.push('result')"
			>
				{{ $t('diagnosis.skip') }}
			</v-button>
		</div>
	</div>
</template>

<style lang="sass">
.mail_form
  &__heading
    text-align: center
    font-size: var(--font-size-small)
    color: var(--white)
    font-weight: var(--font-weight-regular)
    margin: auto
    margin-bottom: 6px
    font-family: var(--font-family-label)
    line-height: 1.6

  &__cover, &__fields
    height: calc(var(--vh, 1vh) * 100)
    box-sizing: border-box
  &__fields
    background-color: var(--black)
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
  .v-cover__image
    background-color: rgba(0, 0, 0, 0.65)
    background-size: 90%
  @media (max-width: 64em)
    .v-cover__image
      background-repeat: no-repeat
      background-size: 249%
      background-position: center center
      background-color: rgba(0, 0, 0, 0.65)
.klaviyo-form
  display: flex
  flex-direction: column
  gap: 1.25rem
  width: 70%
  margin: 0 auto
  .success
    color: green
    text-align: center
  .fail
    color: red
    text-align: center
  .kl-private-reset-css-Xuajs1
    justify-content: center
  input, input::placeholder
    height: none !important
    background: var(--white) !important
    font-weight: var(--font-weight-regular) !important
    font-family: var(--font-family-label) !important
    font-size: var(--font-size-book) !important
    color: var(--black) !important
    border: none !important
    border-bottom: 2px solid var(--white) !important
    padding: 18px 12px !important
    margin-bottom: 5px !important
  button
    display: inline-block !important
    cursor: pointer
    margin: 0px auto 0 auto !important
    font-weight: var(--font-weight-regular) !important
    font-family: var(--font-family-label) !important
    font-size: var(--font-size-book) !important
    background-color: var(--white) !important
    border: 1px solid white !important
    position: relative !important
    padding: 20px 50px !important
    color: var(--black) !important
    &::before
      border: 2px solid black
      content: ''
      pointer-events: none
      position: absolute
      top: 3px
      left: 3px
      z-index: 5
      background: none
      width: calc(100% - 10px)
      height: calc(100% - 10px)
  @media screen and (max-width: 64em)
    width: 94%
    input, input::placeholder
      font-size: 14px !important
      padding: 20px 12px !important
    button
      font-size: 11px !important
    p
      font-size: var(--font-size-mini) !important
      margin-bottom: 0 !important
      &.jp
        font-size: var(--font-size-small) !important
    button
      margin: 20px auto 0 auto !important
      padding: 10px 40px !important

  .text-info-container
    display: flex
    flex-direction: column
    gap: 6px
    text-align: center

  .opt-in-container
    display: flex
    flex-direction: column
    gap: 8px

  .opt-in__multiple
    display: flex
    flex-direction: column
    gap: 8px

  .opt-in__wrapper
    display: flex
    flex-direction: column
    margin-left: 18px

  .opt-in__multiple-start
    font-size: var(--font-size-xtiny)
    color: var(--white)
    line-height: 1.4
    font-family: var(--font-family-text)

  .opt-in
    display: flex
    align-items: center
    gap: 4px
    margin-bottom: 4px

    input[type="checkbox"]
      position: relative
      top: -2px
      appearance: none
      -webkit-appearance: none
      -moz-appearance: none
      border: 1px solid var(--white)
      background-color: transparent
      cursor: pointer
      padding: 6px !important

      &:checked
        background-color: var(--black)
        &::after
          content: '\2714'
          font-size: 12px
          color: var(--black)
          position: absolute
          top: 50%
          left: 50%
          transform: translate(-50%, -50%)

    label
      font-size: var(--font-size-xtiny)
      color: var(--white)
      line-height: 1.4
      font-family: var(--font-family-text)

      a
        color: var(--white)
        text-decoration: underline

  .info-text
    font-size: var(--font-size-mini)
    color: var(--white)
    line-height: 1.8
    font-family: var(--font-family-text)

    a
      color: var(--white)
      text-decoration: underline

  @media screen and (max-width: 64em)
    .opt-in label, .info-text
      font-size: var(--font-size-mini)
</style>

<script>
import VCover from '@/components/VCover'
import VFrame from '@/components/VFrame'
import VButton from '@/components/VButton'

import gsap from 'gsap'

import api from '@/api'
import {
	saveProfile,
	STORAGE_ITEM_NAME,
	COOKIE_KEY_EMAIL,
	setCookie
} from '@/lib/utils'

// Function to hash a string using SHA-256
async function sha256(str) {
	const buffer = new TextEncoder().encode(str)
	const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
	const hashArray = Array.from(new Uint8Array(hashBuffer))
	const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
	return hashHex
}

export default {
	data() {
		return {
			name: '',
			email: '',
			marketingConsent: false,
			dataConsentAllowSendRecap: false,
			dataConsentAllowCollect: false,
			submissionSuccess: null,
			submissionFail: null,
			isLoading: false
		}
	},
	computed: {
		isJapanese() {
			return api.lang === 'jp'
		},
		privacyPolicyText() {
			const url = this.$t('mailForm.privacyPolicyUrl')
			const text = this.$t('mailForm.privacyPolicy')
			return this.$t('mailForm.consent.privacy').replace(
				text,
				`<a href="${url}" target="_blank">${text}</a>`
			)
		},
		diagnosisConsentText() {
			const url = this.$t('mailForm.privacyPolicyUrl')
			const text = this.$t('mailForm.privacyPolicy')
			return this.$t('mailForm.consent.diagnosis').replace(
				text,
				`<a href="${url}" target="_blank">${text}</a>`
			)
		},
		marketingConsentText() {
			const url = this.$t('mailForm.privacyPolicyUrl')
			const text = this.$t('mailForm.privacyPolicy')
			return this.$t('mailForm.consent.marketing').replace(
				text,
				`<a href="${url}" target="_blank">${text}</a>`
			)
		}
	},
	created() {
		this.hasSeenFistPanel = false
		this.hasSeenSecondPanel = false
		this.scroll = { y: 0 }
	},
	components: {
		VCover,
		VFrame,
		VButton
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll)

		setTimeout(async () => {
			if (!this.hasSeenFistPanel) await this.autoScroll(1)
		}, 3000)
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods: {
		async submitForm() {
			this.isLoading = true
			// Basic validation
			if (!this.name || !this.email) {
				console.error('Please fill in all fields.')
				return
			}

			// Consent for sending the recap by mail
			const consentSendRecap =
				this.dataConsentAllowSendRecap && this.dataConsentAllowCollect

			// Consent for subscribing to the newsletter
			const consentSubscribeNewsletter =
				this.dataConsentAllowCollect && this.marketingConsent

			if (!consentSendRecap && !consentSubscribeNewsletter) {
				console.error('Please check the consent fields.')
				return
			}

			// Simple email validation
			const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			if (!emailPattern.test(this.email)) {
				console.error('Please enter a valid email address.')
				return
			}

			const id = this.$store.state.answers.find(
				answer => answer.startsWith('N') || answer.startsWith('Q')
			)

			const skinConcern = Object.values(this.$t(`answers.${id[0]}`)).find(
				answer => answer.bulyExternalid === id
			)?.title

			// Check if the user has consented to the marketing cookies and save its email
			const hasCookieMarketConsent =
				window.OnetrustActiveGroups?.includes('C0004')
			if (hasCookieMarketConsent && this.email && consentSendRecap) {
				setCookie(COOKIE_KEY_EMAIL, this.email, 25 * 30) // 25 months
			}

			const payload = {
				name: this.name,
				email: this.email,
				language: api.lang,
				consentSendRecap,
				consentSubscribeNewsletter
			}

			if (skinConcern) {
				payload.skinConcern = skinConcern
			}

			try {
				const successSubmit = await saveProfile(payload)
				if (!successSubmit) throw new Error('')
				this.submissionSuccess = true
				this.submissionFail = false
				const hashedEmail = await sha256(this.email)
				this.$ga.send(
					this.$constants.ANALYTICS_EVENTS.PRODUCT_FINDER_LEAD,
					{
						product_finder_name:
							this.$constants.PRODUCT_FINDER_NAME,
						hashed_email: hashedEmail
					}
				)
			} catch (error) {
				this.$ga.send(
					this.$constants.ANALYTICS_EVENTS.PRODUCT_FINDER_ERROR,
					{
						product_finder_name:
							this.$constants.PRODUCT_FINDER_NAME,
						error_type: 'save_profile'
					}
				)
				console.error('Failed to save profile.')
				this.submissionFail = true
				this.submissionSuccess = false
			} finally {
				// save the email in session storage for the sendCRMEvent operation in the result page.
				this.email &&
					sessionStorage.setItem(STORAGE_ITEM_NAME, this.email)
				setTimeout(() => {
					this.isLoading = false
					this.$router.push('result')
				}, 1000)
			}

			return
		},
		handleScroll() {
			const scrollTop = window.scrollY
			this.scroll.y = scrollTop
			if (scrollTop >= window.innerHeight) {
				this.hasSeenFistPanel = true
			}
		},
		autoScroll(index) {
			return new Promise(resolve => {
				gsap.to(this.scroll, {
					y: window.innerHeight * index,
					duration: 2,
					ease: 'power2.inOut',
					onUpdate: () => {
						window.scrollTo(0, this.scroll.y)
					},
					onComplete: () => {
						resolve()
					}
				})
			})
		}
	}
}
</script>
